import styled from 'styled-components';

export const List = styled.ol`
  margin: 0;
  padding-left: 22px;
  display: flex;
  flex-direction: column;
  gap: 7px;

  ${({ $plain }) => $plain && `
    list-style: none;
    padding-left: 0;
  `}
`;

export const Item = styled.li`
  font-size: 13.5px;
  line-height: 1.55;
  color: ${({ theme }) => theme.text.workspaceItem};

  &::marker {
    color: ${({ theme }) => theme.text.emptyState};
  }
`;
